
import React, { memo, useState } from 'react';
import styles from './wrapperDraggable.module.scss';
import { handleDrag, handleDrop, handleDragLeave } from './helpers';

const WrapperDraggable = ({ children, previewImage, onDrop, onClick }) => {
    const [isDragging, setIsDragging] = useState(false);

    return (
        <div
            className={`
                ${styles.uploadContainer}
                ${(previewImage || isDragging) && styles.previewImage}
            `}
            onClick={onClick}
            draggable={true}
            onDragEnter={handleDrag.bind(this, setIsDragging)}
            onDragOver={handleDrag.bind(this, setIsDragging)}
            onDragLeave={handleDragLeave.bind(this, setIsDragging)}
            onDrop={handleDrop.bind(this, onDrop, setIsDragging)}
        >
            {children}
        </div>
    )
}

export default memo(WrapperDraggable);